<template>
  <Authenticator class="my-2">
    <div class="md my-2">
      <div v-if="badge_administrators !== null">
        <div class="row px-3 py-2 my-0">
          <h1>Award a badge</h1>
        </div>
        <div class="row px-3">
          <form class="mb-3"
                @submit.prevent="assign_badge">
            <div class="dropdown">
              <button class="btn btn-dark dropdown-toggle my-2 w-100"
                      type="button"
                      data-bs-toggle="dropdown"
                      data-bs-theme="dark"
                      aria-expanded="false">
                {{ selected_badge ? selected_badge.icon + " " + selected_badge.title : 'Select a badge'}}
              </button>
              <ul class="dropdown-menu">
                <li v-for="badge in badges"
                    :key="badge.id">
                  <a class="dropdown-item" href="#" @click.prevent="select_badge(badge.id)">{{badge.icon}} {{badge.title}}</a>
                </li>
              </ul>
            </div>
            <input class="form-control w-100 mb-2"
                   data-bs-theme="dark"
                   name="target_email"
                   :placeholder="'...@'+organisation"
                   required />
            <div class="d-flex flex-column my-1">
              <button type="submit"
                      class="btn btn-outline-light align-self-end"
                      data-bs-theme="dark"
                      :disabled="display_not_admin_text || wait_for_badge_confirmation">
                Award badge
              </button>
            </div>
          </form>
        </div>
        <div class="d-flex justify-content-center align-items-center"
             v-if="wait_for_badge_confirmation">
          <div class="spinner-border m-2 mb-3" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div class="row mx-3">
          <div v-if="award_badge_error"
               class="alert alert-danger"
               role="alert"
               data-bs-theme="dark">
            {{ award_badge_error }}
          </div>
        </div>
        <div class="row mx-3">
          <div v-if="award_badge_warning"
               class="alert alert-warning"
               role="alert"
               data-bs-theme="dark">
            {{ award_badge_warning }}
          </div>
        </div>
        <div class="row mx-3">
          <div v-if="award_badge_success"
               class="alert alert-success"
               role="alert"
               data-bs-theme="dark">
            {{ award_badge_success }}
          </div>
        </div>
        <div class="row mx-3">
          <div v-if="display_not_admin_text"
               class="alert alert-light"
               role="alert"
               data-bs-theme="dark">
            <span>
              You cannot award a badge because you are not a badge administrator for your organisation.
              The badge administrator(s) of your organisation is/are:
            </span>
            <ul class="mb-0">
              <li v-for="admin in badge_administrators"
                  :key="admin">
                {{admin}}
              </li>
            </ul>
          </div>
        </div>
        <div class="row mx-3">
          <div v-if="display_no_administrators_text"
               class="alert alert-light"
               role="alert"
               data-bs-theme="dark">
            <span>
              Your organization ({{"...@"+this.organisation}}) has no badge administrators yet.
              By awarding this badge, you will become a badge administrator for your organization.
              Only badge administrators can award badges.
              Other members of your organization will be able to see that you are a badge administrator.
            </span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-center align-items-center"
           v-if="badge_administrators === null">
        <div class="spinner-border m-2" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </Authenticator>
</template>
<script>
  import Authenticator from '@/authenticator/authenticator.js'
  import { get_email, get_badge_administrators, post_badge, post_user } from '@/backend/backend.js'
  import { get_valid_email, badges } from '@/badges/badges.js'
  export default {
    components: {
      Authenticator
    },
    data() {
      return {
        viewer_email: null,
        award_badge_error: null,
        award_badge_warning: null,
        award_badge_success: null,
        badge_administrators: null,
        badges: [...badges].sort((a, b) => a.id.localeCompare(b.id)),
        selected_badge: null,
        wait_for_badge_confirmation: false,
      }
    },
    created() {
       document.title = "Award a badge"
    },
    mounted() {
      get_email().then(
        email => {this.viewer_email = email}
      )

      get_badge_administrators()
        .then(badge_administrators => {

          if (!badge_administrators) {
            console.debug('There are no badge administrators')
            return
          }

          this.badge_administrators = badge_administrators
        })

      post_user()
    },
    methods: {
      assign_badge(submit_event) {
        this.award_badge_error = null
        this.award_badge_warning = null
        this.award_badge_success = null

        var data = new FormData(submit_event.target)
        var data_object = {}
        data.forEach((value, key) => {
          data_object[key] = value
        })
        var target_email = get_valid_email(data_object.target_email)
        if (!target_email) {
          this.award_badge_error = "Email is not valid."
          return
        }
        var target_organisation = target_email.split('@')[1]
        if (target_organisation != this.organisation) {
          this.award_badge_error = "You can only award badges to members of your own organisation (...@" + this.organisation + ")."
          return
        }
        if (!this.selected_badge) {
          this.award_badge_error = "Please select a badge."
          return
        }

        this.wait_for_badge_confirmation = true
        post_badge(target_email, this.selected_badge.id)
          .then(api_response => {
            this.wait_for_badge_confirmation = false

            if (!api_response) {
              console.debug('There are no badges')
              return
            }

            this.award_badge_error = api_response.error
            this.award_badge_warning = api_response.warning
            this.award_badge_success = api_response.success
          })

      },
      select_badge(badge_id) {
        var selected_badge = null
        this.badges.forEach(badge => {
          if (badge.id == badge_id) {selected_badge = badge}
        })
        this.selected_badge = selected_badge;
      }
    },
    computed: {
      organisation() {
        if (!this.viewer_email) { return null }
        return this.viewer_email.split('@')[1]
      },
      display_not_admin_text() {
        if (this.badge_administrators === null) { return false }
        if (this.badge_administrators.includes(this.viewer_email)) { return false }
        if (this.badge_administrators.length == 0) { return false}
        return true
      },
      display_no_administrators_text() {
        if (this.badge_administrators === null) { return false }
        if (this.badge_administrators.includes(this.viewer_email)) { return false }
        if (this.badge_administrators.length == 0) { return true }
        return false
      },
    }
  }
</script>
<style scoped>
  .md {
    text-align: left;
    background-color: rgb(43, 43, 43);
    border-radius: 10px;
  }
  .dropdown-menu {
    background-color: #343a40;
  }
  .dropdown-item {
    color: white;
  }
</style>
